import styled from "styled-components";
import dayjs from "dayjs";

import { PdtIcon } from "../atoms/PdtIcon";
import { Typography } from "../atoms/Typography";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { Button } from "../atoms/Button";

export type ContractWithDates = {
  id: string;
  pdt: { id: string; name: string; iconPath: string };
  createdAt: string;
  deletedAt?: string | null;
};

type ContractListProps = {
  contracts: ContractWithDates[];
  onCancelClick: (contractId: string) => void;
  isCsUser: boolean;
};

const flexRatio = [0.3, 1, 1, 1, 1];

const headerTitles = ["製品", "PDT種別", "契約日", "ステータス", ""];

const ButtonWrapper = styled.div`
  width: 140px;
  height: 30px;
  margin-left: auto;
`;

export function ContractList({
  contracts,
  onCancelClick,
  isCsUser,
}: ContractListProps) {
  const items = contracts.map((contract) => {
    const isActive = !contract.deletedAt;

    return (
      <DataListRow flexRatio={flexRatio} key={contract.id}>
        <DataListBodyItem>
          <PdtIcon
            size={40}
            src={contract.pdt.iconPath}
            alt={contract.pdt.name}
          />
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2}>{contract.pdt.name}</Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2}>
            {dayjs(contract.createdAt).format("YYYY/MM/DD")}
          </Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2}>{isActive ? "契約中" : "解約済み"}</Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          {isActive && isCsUser && (
            <ButtonWrapper>
              <Button
                buttonType="danger"
                onClick={() => onCancelClick(contract.id)}
              >
                解約処理する
              </Button>
            </ButtonWrapper>
          )}
        </DataListBodyItem>
      </DataListRow>
    );
  });

  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={items} />
    </DataTable>
  );
}
